import {
  CALIBRATION_DEVICE_RAIL_STATUS_MESSAGES,
  calibrationDeviceRailBranchVariants,
  calibrationDeviceRailDeviceVariants,
  calibrationDeviceRailStatusVariants,
} from '@/features/calibration/config/calibrationDeviceRail';
import type { CalibrationDeviceTreeRow } from '@/features/calibration/types/calibrationDeviceTree';
import { useLingui } from '@lingui/react/macro';
import { Link } from '@tanstack/react-router';
import type { CSSProperties, Ref } from 'react';

export function CalibrationDeviceRailDeviceRow({
  row,
  activeDeviceId,
  measureRef,
  virtualIndex,
  style,
}: {
  row: Extract<CalibrationDeviceTreeRow, { kind: 'device' }>;
  activeDeviceId?: string;
  measureRef: Ref<HTMLLIElement>;
  virtualIndex: number;
  style: CSSProperties;
}) {
  const { i18n } = useLingui();
  const active = activeDeviceId === row.device.deviceId;
  const calibrationStatus = row.device.calibrationVersions.length > 0 ? 'active' : 'none';

  return (
    <li ref={measureRef} data-index={virtualIndex} style={style}>
      <div className={calibrationDeviceRailBranchVariants({ edge: row.edge })}>
        <Link
          to="/calibration/devices/$deviceId"
          params={{ deviceId: row.device.deviceId }}
          data-active={active}
          className={calibrationDeviceRailDeviceVariants({ active })}
        >
          <span className="min-w-0 flex-1 truncate">
            {row.device.opsCode ?? row.device.deviceId}
          </span>
          <span className={calibrationDeviceRailStatusVariants({ status: calibrationStatus })}>
            {i18n._(CALIBRATION_DEVICE_RAIL_STATUS_MESSAGES[calibrationStatus])}
          </span>
        </Link>
      </div>
    </li>
  );
}
